import { gql, useQuery } from '@apollo/client';

import {
  useSponsorPaywallModal_PaywallQuery,
  useSponsorPaywallModal_PaywallQueryVariables,
} from './graphql-types/useSponsorPaywallModal_PaywallQuery';

const PAYWALL_QUERY = gql`
  query useSponsorPaywallModal_PaywallQuery($input: SingleOrganizationInput!) {
    organization(input: $input) {
      result {
        _id
        sponsorship {
          currentTier {
            shouldShowUpgradeCTA
            deletePostPaywallText {
              title
              subtitle
            }
          }
        }
      }
    }
  }
`;

export const useSponsorPaywallModal = (options: {
  organizationId?: string;
}): {
  title?: string;
  subtitle?: string;
  shouldShowUpgradeCTA?: boolean;
} => {
  const { organizationId } = options;

  const { data: paywallData } = useQuery<
    useSponsorPaywallModal_PaywallQuery,
    useSponsorPaywallModal_PaywallQueryVariables
  >(PAYWALL_QUERY, {
    variables: {
      input: {
        id: organizationId,
      },
    },
    skip: !organizationId,
  });
  const currentTier =
    paywallData?.organization?.result?.sponsorship?.currentTier;

  return {
    title: currentTier?.deletePostPaywallText?.title || undefined,
    subtitle: currentTier?.deletePostPaywallText?.subtitle || undefined,
    shouldShowUpgradeCTA: currentTier?.shouldShowUpgradeCTA,
  };
};
